import { render, staticRenderFns } from "./SealSystem.vue?vue&type=template&id=18779af3&scoped=true"
import script from "./SealSystem.vue?vue&type=script&lang=js"
export * from "./SealSystem.vue?vue&type=script&lang=js"
import style0 from "./SealSystem.vue?vue&type=style&index=0&id=18779af3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18779af3",
  null
  
)

export default component.exports